import { IResponse } from "models";

export enum ActionType {
  DOWNLOAD_PATIENT_CSV = "action/DOWNLOAD_PATIENT_CSV",
  DOWNLOAD_PATIENT_CSV_SUCCESS = "action/DOWNLOAD_PATIENT_CSV_SUCCESS",
  DOWNLOAD_PATIENT_CSV_ERROR = "action/DOWNLOAD_PATIENT_CSV_ERROR",
  DOWNLOAD_PATIENT_CSV_RESET = "action/DOWNLOAD_PATIENT_CSV_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IPatientCSVData {
  id: number;
  name: string;
  gender: string;
  age: number;
  date_of_birth: string;
}

export interface IPatientCSVResponse extends IResponse {
  result: {
    headers: {
      label: string;
      key: string;
    }[];
    data: IPatientCSVData[];
  };
}
